import { ICellRendererParams } from 'ag-grid-community';
import { User } from 'data/members/api';
import { TemplateObjectType } from 'data/templates/api';
import { fullName } from 'utils/full-name';
import { sortByText } from 'utils/sort-by-text';
import { TemplateListProp } from '../types';

interface Data {
  data: TemplateListProp;
}
type WithData<AgGridType> = Pick<
  AgGridType,
  Exclude<keyof AgGridType, 'data'>
> &
  Data;

export type TemplateCellRendererParams = WithData<ICellRendererParams>;

export const userNameSorter = (prevUser: User, nextUser: User): number =>
  sortByText(
    prevUser ? fullName(prevUser) : '',
    nextUser ? fullName(nextUser) : '',
  );

export const templateNameSorter = (a: string, b: string): number => {
  return sortByText(a, b);
};

export const dateSorter = (a = 0, b = 0): number => {
  return a - b;
};

export const getPrivateRowStyles = (objectType, params) => {
  if (objectType === TemplateObjectType.StatusUpdates && params.data?.private) {
    return {
      '--ag-odd-row-background-color': 'var(--private-01)',
      '--ag-background-color': 'var(--private-02)',
      '--ag-row-hover-color': 'var(--private-02)',
    };
  }

  return null;
};
